import { formatTimeAgo } from '@/utils/post/utils';
import classNames from 'classnames';
import { postCardTimestamp } from '../Post.css';

const formatPostTime = (postTimeISO: string, style: string) => {
  const postTime = new Date(postTimeISO);

  // Handle different styles
  switch (style) {
    case 'short_date':
      return postTime.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    case 'numeric_date':
      return postTime.toLocaleDateString('en-US');
    case 'iso_date':
      return postTime.toISOString().split('T')[0]; // ISO format
    case 'day_first':
      return postTime.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    case 'month_year':
      return postTime.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
      });
    case 'time_ago':
      return formatTimeAgo(postTime);
    default:
      // Fallback to a standard format if the style is unknown
      return postTime.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });
  }
};

const ALIGN_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

interface Props {
  timestamp: string;
  timestampDisplay?: string;
  alignment?: 'left' | 'center' | 'right' | undefined;
  className?: string;
}

const Timestamp = ({ timestamp, timestampDisplay = 'short_date', alignment, className }: Props) => {
  return (
    <div className={classNames('flex', ALIGN_OPTIONS[alignment || 'left'], className)}>
      <span className={classNames(postCardTimestamp, 'text-xs w-fit whitespace-nowrap')}>
        {formatPostTime(timestamp, timestampDisplay)}
      </span>
    </div>
  );
};

export default Timestamp;
